@if(!(_userService.isLoggedIn$ | async)) {
    <div class="mb-3">
        <p>Login to acces fan features</p>
    </div>
    <div>
        <button class="btn-txt btn-gray mr-2"
            (click)="login()">
            Login
        </button>
        <button class="btn-txt btn-gray btn-outline"
            (click)="signUp()">
            Sign-up
        </button>
    </div>
}
@else {
    <div class="text-right">
        <button class="btn-txt btn-gray mr-2"
            (click)="logout()">
            Logout
        </button>
    </div>
}
